<template>
  <div>
    <div class="cartTotalTab row g-3">
      <h2><span>2022 TT曜越單車電競爭霸戰<br>風險告知與免責聲明書同意書</span></h2>
      <div class="col-md-12 themeBox">
        <div class="word">
          <div class="info">
            <ul>
              <li>歡迎您報名「2022TT曜越單車電競爭霸戰」！為了保障您的權益，請務必詳讀本同意書的各項內容。當您閱讀完畢並按下「我接受」的按鈕，即視為您已閱讀並了解本同意書的內容，並且確認絕對遵守。</li>
              <li>
                <strong>本人參加主辦單位：曜越單車(以下簡稱甲方)舉辦之「2022 TT曜越單車電競爭霸戰」(以下稱本活動)。已知本活動具有一定風險，並同意遵守下列參加條款及所有相關規定：</strong>
                <ul>
                  <li>參賽選手本人出於自願參加本次由甲方所舉辦之賽事活動。本人同意承擔賽事可能發生之所有風險，前述風險包含可能因本人或他人的行為或疏忽、或身體或車輛等因素造成。或因對相關器材、設施、場地不熟悉造成。並明確了解該等行為可能造成身體及生命之傷害及財產損失。本人在此聲明，對上述事項明確知悉，並願自行負擔及承受本活動所發生一切風險。</li>
                  <li>本人明白此活動為體能運動賽事，已詳細閱覽本活動相關說明及規定。且本人身體健康，沒有任何不適宜參加本活動知身體損傷或疾病。</li>
                  <li>本人於往返活動場地途中，活動期間引起之自身意外、死亡或任何形式的損失，本人無權向活動單位(主辦、承辦、贊助與合作單位)提出索償或追討任何法律責任。</li>
                  <li>本人已詳細閱讀並了解本活動的相關說明及規定，並同意遵守。</li>
                  <li>本人明白在參加本活動過程中，如有任何不適應自行停止繼續比賽。</li>
                  <li>本人同意活動單位(主辦、承辦、贊助與合作單位)可於活動中拍照、錄影或以其他任何形式製作本次活動紀錄。並授權活動單位(主辦、承辦、贊助與合作單位)可將拍攝之素材(包括但不限於之姓名、肖像、影像拍攝、圖片、照片與紀錄等)利用於包括廣告與促銷等各種宣傳用途，以及利用於現在或將來已知的所有媒體，該授權為不受任何限制之永久性免費授權。</li>
                  <li>本人在報名表格內所填報的資料全部屬實，亦符合主辦單位所訂的參加資格，並同意若有虛報資料，將會被即時取消所有參加資格。</li>
                  <li>本人願意服從大會最終結果。</li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="terms"><!-- checkbox 點了會 false 跟 true 做切換 -->
            <label class="form-check-label">勾選此框並按下我接受按鈕，即表示您同意您已閱讀、並且了解和接受此同意書所有相關內容與規範。若您不同意這些內容與規範，將無法完成報名程序。</label>
          </div>
        </div>
      </div>
      <div class="cartBtnBox">
        <!-- <div class="btnCarAgree"><button type="submit" @click="playerApply(form)" class="btn btn--primary" :disabled="isDisabled">我要報名</button></div> -->
        <div class="btnCarAgree"><button type="submit" @click="goApply('Apply')" class="btn btn--primary" :disabled="isDisabled">我要報名</button></div><!-- 點送出後把組件改回 Apply -->
        <div class="clearer"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-check {
  text-align: center;
  border-top: 1px solid #c9bb90;
  padding-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form-check .form-check-input {
  vertical-align: middle;
  /* display: inline-block; */
  float: none;
  margin: 0;
  min-width: 20px;
  min-height: 20px;
}
label {
  vertical-align: middle;
  font-size: 15px;
  line-height: 25px;
  text-align: left;
  padding: 0 10px;
}
.themeBox .info > ul {
  list-style: none;
}
</style>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  data() {
    return {
      terms: false,
    }
  },
  methods: {
    // ...mapActions(['playerApply']),
    goApply(name) {
      this.$store.dispatch('playerApply', this.form)
      this.$emit('emit-component', name)
    },
    // emitApply() {
    //   this.$emit('emit-apply')
    // },
  },
  computed: {
    ...mapState({
      form: 'form',
      // form: state => state.form,
    }),
    isDisabled() {
      console.log(this.terms)
      return !this.terms
    },
  },
}
</script>